import api from '@/services/api'

export default {
  state: {},

  mutations: {},

  actions: {
    async saveEvento({ commit }, data) {
      try {
        return await api.post('/eventos', data)
      } catch (error) {
        throw error
      }
    },

    async getEventos({ commit }, filters) {
      try {
        const params = new URLSearchParams(filters)

        const response = await api.get(`/eventos?${params}`)

        return response && response.data ? response.data : null
      } catch (error) {
        throw error
      }
    },

    async getEventosByOrcamento({ commit }, data) {
      try {
        const response = await api.get(
          `/centros-custos/${data.codCCustoPai}/orcamento/${data.orcamentoId}/eventos`,
        )

        return response && response.data ? response.data : null
      } catch (error) {
        throw error
      }
    },

    async getEvento({ commit }, eventoId) {
      try {
        const response = await api.get(`/eventos/${eventoId}`)

        return response && response.data ? response.data : null
      } catch (error) {
        throw error
      }
    },

    async updateEvento({ commit }, data) {
      try {
        return await api.put(`/eventos/${data.eventoId}`, data.evento)
      } catch (error) {
        throw error
      }
    },

    async deleteEvento({ commit }, eventoId) {
      try {
        return await api.delete(`/eventos/${eventoId}`)
      } catch (error) {
        throw error
      }
    },

    async avaliationEvento({ commit }, data) {
      try {
        return await api.post(`/eventos/${data.eventoId}/avaliacao`, data)
      } catch (error) {
        throw error
      }
    },

    async linkEventosOrcamento({ commit }, data) {
      try {
        return await api.post('/eventos/vincular-orcamento', data)
      } catch (error) {
        throw error
      }
    },

    async unlinkEventosOrcamento({ commit }, data) {
      try {
        return await api.post('/eventos/desvincular-orcamento', data)
      } catch (error) {
        throw error
      }
    },
  },

  getters: {},
}
